import type { LegalDoc } from './types';

export const grievancePolicy: LegalDoc = {
  slug: 'grievance',
  title: 'Grievance Redressal Policy',
  effectiveDate: '2026-06-15',
  lastUpdated: '2026-10-11',
  intro:
    `Sansara is committed to resolving your concerns fairly and quickly. This Grievance Redressal Policy is published in compliance with the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, the Digital Personal Data Protection Act, 2023, and the Consumer Protection Act, 2019. It tells you how to raise a complaint, who handles it, and the timelines you can expect.`,
  sections: [
    {
      heading: 'Grievance Officer',
      paragraphs: [
        `In accordance with Rule 3(2) of the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, we have appointed a Grievance Officer who is responsible for receiving and resolving complaints regarding the Platform, its content and the handling of your personal data.`,
      ],
      bullets: [
        `Name: Sansara Finotech Private Limited`,
        `Designation: Grievance Officer, Sansara Finotech Private Limited (a private limited company currently under incorporation)`,
        `Email: grievance@sansarafin.com`,
        `Postal address: Kanpur, Uttar Pradesh, India`,
        `Working hours: Monday to Friday, 10:00 to 18:00 IST (excluding public holidays)`,
      ],
    },
    {
      heading: 'What You Can Complain About',
      paragraphs: [
        `You may raise a grievance about any of the following:`,
      ],
      bullets: [
        `the collection, use, sharing, accuracy, retention or deletion of your personal data, and the exercise of your rights under the DPDP Act;`,
        `content on the Platform that you believe is unlawful, inaccurate or in breach of these terms or the IT Rules, 2021;`,
        `account access, security or unauthorised use concerns;`,
        `subscription, billing, cancellation and refund matters;`,
        `any other issue concerning your use of the Platform or our services.`,
      ],
    },
    {
      heading: 'How to Raise a Grievance',
      paragraphs: [
        `Please send your complaint by email to grievance@sansarafin.com from your registered email address, or by post to the Grievance Officer at the address above. To help us resolve it quickly, include:`,
      ],
      bullets: [
        `your name and registered email/mobile number;`,
        `a clear description of the issue and what outcome you are seeking;`,
        `relevant dates, transaction references or screenshots;`,
        `if the complaint is about personal data, the right you wish to exercise (for example, access, correction or erasure).`,
      ],
    },
    {
      heading: 'Acknowledgement and Resolution Timelines',
      paragraphs: [
        `We will acknowledge your grievance within twenty-four (24) hours of receipt, as required under the IT Rules, 2021. We will dispose of the grievance and communicate our resolution as soon as practicable and in any case within fifteen (15) days of receipt. Where a matter requires more information from you, the time we wait for your response will not count toward the fifteen-day period, and we will tell you what we need.`,
        `For requests to remove certain categories of content that the law treats as especially time-sensitive (for example, content prescribed under Rule 3(2)(b) of the IT Rules, 2021), we will act within the shorter timelines required by law.`,
      ],
    },
    {
      heading: 'How We Handle Your Complaint',
      paragraphs: [
        `On receipt, we record your complaint with a reference number, assess it, and where needed coordinate with our service providers (such as Razorpay for payment matters or our hosting provider for technical matters). We will keep you informed of progress and tell you the outcome and the reasons for our decision. We treat all complaints confidentially and handle your data in line with our Privacy Policy.`,
      ],
    },
    {
      heading: 'Data Principal Rights Requests',
      paragraphs: [
        `If your grievance concerns your personal data, the Grievance Officer also serves as the contact point for exercising your rights under the DPDP Act — including access, correction, completion, updating, erasure, nomination and withdrawal of consent. We may take reasonable steps to verify your identity before acting on such a request, to protect your data from unauthorised access.`,
      ],
    },
    {
      heading: 'Escalation to the Data Protection Board',
      paragraphs: [
        `If your grievance relates to personal data and you are not satisfied with our response, or we do not respond within the prescribed time, you have the right to lodge a complaint with the Data Protection Board of India, established under the DPDP Act, in the manner that the Board prescribes. We encourage you to first allow us the opportunity to resolve the matter.`,
      ],
    },
    {
      heading: 'Escalation for Consumer Matters',
      paragraphs: [
        `For consumer disputes (for example, billing or service quality) that remain unresolved, you may also approach the appropriate consumer grievance forums under the Consumer Protection Act, 2019, including the National Consumer Helpline. Nothing in this policy limits your statutory rights.`,
      ],
    },
    {
      heading: 'No Investment-Advice Grievances',
      paragraphs: [
        `Because Sansara is not a SEBI-registered Research Analyst or Investment Adviser and provides no investment advice or recommendations, grievances about the merits or outcome of any investment decision fall outside the scope of our services. If you have a complaint about a trade executed on your own broker account, please raise it with your broker, whose own grievance mechanism and the relevant SEBI/exchange channels (such as SCORES) will apply.`,
      ],
    },
    {
      heading: 'Updates to This Policy',
      paragraphs: [
        `We may update this policy to reflect changes in law or our practices. The current version, with the Grievance Officer's details and the latest timelines, will always be available on sansarafin.com and within the app.`,
      ],
    },
  ],
};
